/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlanGroup/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlanGroup({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlanTemplates/Content/Content/TreatmentPlanTable/Header/NavigateTo/Content/Content/TreatmentPlanGroup"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  closePopover,
  viewPath
  
})
let treatmentPlanGroupNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan_group',
path: 'name',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 width="100%"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="treatment_plan_group.name"
 text={treatmentPlanGroupNameValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}